import Step1 from './icons/step-1.svg'
import Step2 from './icons/step-2.svg'
import Step3 from './icons/step-3.svg'
import Step4 from './icons/step-4.svg'
import Step5 from './icons/step-5.svg'

export const steps = [
  {
    img: Step1,
    text: 'Fill out and submit the form.'
  },
  {
    img: Step2,
    text: 'Receive billing from customer support.'
  },
  {
    img: Step3,
    text: 'Settle payment via Paypal invoice.'
  },
  {
    img: Step4,
    text: 'Receive purchase confirmation from customer support.'
  },
  {
    img: Step5,
    text: 'Wait for your item to be delivered at the warehouse.'
  },
]

export const stepFillOut = [
  {
    icon: 'https://cdn.shippingcart.com/assets/group_2672@2x-20220615022138.png',
    text: 'Fill up form',
    isActive: true
  },
  {
    icon: 'https://cdn.shippingcart.com/assets/ellipse_7-20220615022122.png',
    text: 'Confirmation',
    isActive: false
  },
  {
    icon: 'https://cdn.shippingcart.com/assets/ellipse_7-20220615022122.png',
    text: 'Success',
    isActive: false
  },
]
export const stepConfirmation= [
  {
    icon: 'https://cdn.shippingcart.com/assets/group_2672@2x-20220615022138.png',
    text: 'Fill up form',
    isActive: true
  },
  {
    icon: 'https://cdn.shippingcart.com/assets/group_2672@2x-20220615022138.png',
    text: 'Confirmation',
    isActive: true
  },
  {
    icon: 'https://cdn.shippingcart.com/assets/ellipse_7-20220615022122.png',
    text: 'Success',
    isActive: false
  }
]
export const stepSuccess = [
  {
    icon: 'https://cdn.shippingcart.com/assets/group_2672@2x-20220615022138.png',
    text: 'Fill up form',
    isActive: true
  },
  {
    icon: 'https://cdn.shippingcart.com/assets/group_2672@2x-20220615022138.png',
    text: 'Confirmation',
    isActive: true
  },
  {
    icon: 'https://cdn.shippingcart.com/assets/group_2672@2x-20220615022138.png',
    text: 'Success',
    isActive: true
  },
]


/** WEBPACK FOOTER **
 ** ./src/components/BuyForMe/constants.js
 **/